module.exports = "<div class=\"container\">\n  <div class=\"row mt-4 mb-4\">\n      <ul>\n        <li><a routerLink=\"/carga/zonas\">Zonas</a></li>\n        <li><a routerLink=\"/carga/barrios\">Barrios</a></li>\n        <li><a routerLink=\"/carga/os\">Obras Sociales</a></li>\n        <li><a routerLink=\"/carga/centros\">Centros de Salud</a></li>\n        <li><a routerLink=\"/carga/profesionales\">Profesionales</a></li>\n      </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/carga.component.html
// module id = ../../../../../src/app/carga/carga.component.html
// module chunks = 1